"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var Placeholder =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Placeholder, _Activity);

  function Placeholder() {
    babelHelpers.classCallCheck(this, Placeholder);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Placeholder).apply(this, arguments));
  }

  return Placeholder;
}(_base.default);

exports.default = Placeholder;